import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Text */}
            <div className="order-2 md:order-1">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 tracking-tight mb-4">
                {t('about_title')}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                {t('about_p1')}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                {t('about_p2')}
              </p>
              <a
                href="/about"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
              >
                {t('about_cta')}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>

            {/* Image */}
            <div className="order-1 md:order-2">
              <div className="rounded-xl overflow-hidden aspect-[4/3] bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Fashion%20shopping%20lifestyle%20flat%20lay%20aesthetic%20minimalist%20photography%20premium%20streetwear%20products%20arranged%20on%20clean%20neutral%20surface%20warm%20natural%20lighting%20editorial%20style%20ecommerce%20collection&width=800&height=600&seq=about-img-01&orientation=landscape"
                  alt="About AllChinaBuy Spreadsheet"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}